import React, { ReactNode, useState } from "react";
import { Icon } from "src/components";

interface Props {
  title: string;
  children: ReactNode;
  collapseIcon?: ReactNode;
  expandIcon?: ReactNode;
}

const Accordion = (props: Props) => {
  const [isActive, setIsActive] = useState(false);
  const collapseIcon = props.collapseIcon ? (
    props.collapseIcon
  ) : (
    <Icon name="chevron" className="rotate-90 w-4 h-4" />
  );
  const expandIcon = props.expandIcon ? (
    props.expandIcon
  ) : (
    <Icon name="chevron" className="-rotate-90 w-4 h-4" />
  );

  return (
    <div className="flex flex-col">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setIsActive(!isActive)}
      >
        <div>{props.title}</div>
        <div>{isActive ? collapseIcon : expandIcon}</div>
      </div>
      {isActive && <div className="accordion-content">{props.children}</div>}
    </div>
  );
};

export default Accordion;
